<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vii"></a>
<h1 class="toc-title"><span class="bold">Contents</span></h1>
<h2 class="toca"><a href="#/xhtml/06_Acknowledgements#ack"><em class="italic">Acknowledgements</em></a></h2>
<h2 class="toca"><a href="#/xhtml/07_List#list"><em class="italic">List of Illustrations</em></a></h2>
<h2 class="toca"><a href="#/xhtml/08_Introduction#int"><em class="italic">Introduction</em></a></h2>
<h2 class="toc"><a href="#/xhtml/09_Chapter01#chapter1"><span class="toc_hang"><span class="bold">Chapter 1</span></span> Military Railways</a></h2>
<h2 class="toc"><a href="#/xhtml/10_Chapter02#chapter2"><span class="toc_hang"><span class="bold">Chapter 2</span></span> Railways Before the Second World War</a></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter03#chapter3" title="Link target outside of Sample"><span class="toc_hang"><span class="bold">Chapter 3</span></span> 1939</span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter04#chapter4" title="Link target outside of Sample"><span class="toc_hang"><span class="bold">Chapter 4</span></span> 1940</span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter05#chapter5" title="Link target outside of Sample"><span class="toc_hang"><span class="bold">Chapter 5</span></span> 1941</span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter06#chapter6" title="Link target outside of Sample"><span class="toc_hang"><span class="bold">Chapter 6</span></span> 1942</span></h2>
<h2 class="toc"><span href="#/xhtml/15_Chapter07#chapter7" title="Link target outside of Sample"><span class="toc_hang"><span class="bold">Chapter 7</span></span> 1943</span></h2>
<h2 class="toc"><span href="#/xhtml/16_Chapter08#chapter8" title="Link target outside of Sample"><span class="toc_hang"><span class="bold">Chapter 8</span></span> 1944</span></h2>
<h2 class="toc"><span href="#/xhtml/17_Chapter09#chapter9" title="Link target outside of Sample"><span class="toc_hang"><span class="bold">Chapter 9</span></span> 1945</span></h2>
<h2 class="toc"><span href="#/xhtml/18_Chapter10#chapter10" title="Link target outside of Sample"><span class="toc_hang"><span class="bold">Chapter 10</span></span> Reflection</span></h2>
<h2 class="tocat"><span href="#/xhtml/19_Afterword#after" title="Link target outside of Sample"><em class="italic">Afterword</em></span></h2>
<h2 class="tocs"><span href="#/xhtml/20_Appendix01#app1" title="Link target outside of Sample"><span class="toc_hang"><em class="italic">Appendix I</em></span> <em class="italic">Second World War Railway Memorials</em></span></h2>
<h2 class="tocs"><span href="#/xhtml/21_Appendix02#app2" title="Link target outside of Sample"><span class="toc_hang"><em class="italic">Appendix II</em></span> <em class="italic">Commemorative Second World War Locomotives and Railway vehicles</em></span></h2>
<h2 class="tocat"><span href="#/xhtml/22_Glossary#glos" title="Link target outside of Sample"><em class="italic">Glossary</em></span></h2>
<h2 class="toca"><span href="#/xhtml/23_Bibliography#bib" title="Link target outside of Sample"><em class="italic">Bibliography</em></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?675e91e4